import * as React from 'react';

import { SparkleIcon } from 'bundles/ai-course-coach/assets/mui';
// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import { CoachButton } from 'bundles/ai-course-coach/components/common';

import _t from 'i18n!nls/learning-assistant-chat-ai';

import type { Props as CoachButtonProps } from './CoachButton';

type Props = { children: string } & CoachButtonProps;

/**
 * Simple wrapper around CoachButton to provide some specific styles.
 */
export const CoachTriggerButton = (props: Props): React.ReactElement => {
  const { children, ...rest } = props;

  return (
    <CoachButton
      variant="secondary"
      size="small"
      aria-label={_t('#{label}, #{coachLabel} trigger', { label: children, coachLabel: 'Coach' })}
      icon={<SparkleIcon />}
      iconPosition="before"
      {...rest}
    >
      {children}
    </CoachButton>
  );
};

export default CoachTriggerButton;
